import React, { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import moment from "moment";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import CustomTable from "../../../components/table/table";
import {
  adminInternshipsDoingList,
  superadminInternshipsDoingList,
} from "../admin.api";
import "./style.css";
import * as XLSX from "xlsx";
import { FiEye } from "react-icons/fi";


const getStatusInfo = (status) => {
  const statusMap = {
    evaluation: {
      label: "Evaluation",
      class: "info",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
      )
    },
    doing: {
      label: "Internship Doing",
      class: "warning",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>
      )
    },
    certified: {
      label: "Certified",
      class: "successs",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      )
    },
  };
  const defaultIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="16" x2="12" y2="12"></line>
      <line x1="12" y1="8" x2="12.01" y2="8"></line>
    </svg>
  );
  return statusMap[status] || {
    label: status?.charAt(0).toUpperCase() + status?.slice(1),
    class: "secondary",
    icon: defaultIcon
  };
};

export default function InternshipsDoingList(props) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [showFilters, setShowFilters] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [filters, setFilters] = useState({
    status: "",
  });

  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const fetchInternshipsDoing = () => {
    setIsLoading(true);
    const apiCall =
      adminType === 2
        ? superadminInternshipsDoingList(page, perPage, filters)
        : adminInternshipsDoingList(page, perPage, filters);

    apiCall
      .then((res) => {
        if (res?.success) {
          let tdata = res.data || [];
          tdata.forEach((item, index) => {
            item["slno"] = (page - 1) * perPage + index + 1;
          });
          setData(tdata);
          setTotalPages(res.pagination?.last_page || 1);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching internships doing:", error);
        setSnackMessage("Failed to load internship directory");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchInternshipsDoing();
  }, [page, perPage, filters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
    setPage(1);
  };

  const handlePerPageChange = (e) => {
    const value = e.target.value;
    setPerPage(value === "All" ? "all" : parseInt(value));
    setPage(1);
  };

  const renderPagination = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    if (start > 1) {
      pages.push(
        <button key={1} className="btn btn-sm btn-outline-primary" onClick={() => setPage(1)}>1</button>
      );
      if (start > 2) pages.push(<span key="start-dots" className="px-1 text-primary">...</span>);
    }

    for (let i = start; i <= end; i++) {
      pages.push(
        <button
          key={i}
          className={`btn btn-sm ${page === i ? "btn-primary text-white" : "btn-outline-primary"}`}
          onClick={() => setPage(i)}
        >
          {i}
        </button>
      );
    }

    if (end < totalPages) {
      if (end < totalPages - 1) pages.push(<span key="end-dots" className="px-1 text-primary">...</span>);
      pages.push(
        <button key={totalPages} className="btn btn-sm btn-outline-primary" onClick={() => setPage(totalPages)}>{totalPages}</button>
      );
    }

    return pages;
  };

  const handleView = (row) => {
    // Navigate to internship request detail page
    let path = `/admin-internship-requests/${row.internship_request_id}`;
    props.history.push(path);
  };

  const snackbarClose = () => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
  };

  async function fetchExportData() {
    const exportdata = [];
    data.forEach((item, index) => {
      exportdata.push({
        "Sl No": index + 1,
        "Intern Name": item.internship?.full_name || "--",
        "Company": item.internship_request?.company?.company_name || "--",
        "Discipline": item.internship_request?.internship_discipline || "--",
        "Start Date": item.start_date
          ? moment(item.start_date).format("DD-MMM-YYYY")
          : "--",
        "Completion Date": item.completion_date
          ? moment(item.completion_date).format("DD-MMM-YYYY")
          : "--",
        "Status": getStatusInfo(item.status).label,
      });
    });
    return exportdata;
  }

  const downloadExcel = async () => {
    setIsDownloading(true);
    try {
      // Small delay to ensure loading state is visible
      await new Promise(resolve => setTimeout(resolve, 500));
      const exportData = await fetchExportData();

      if (!exportData.length) {
        setSnackMessage("No data available to download");
        setIsSnackError(true);
        setSnackOpen(true);
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Internship Doing");

      XLSX.writeFile(workbook, "Internship_Doing_Directory.xlsx");
    } catch (error) {
      console.error("Error downloading Excel:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
      <div className="container-fluid mt-4">
      <Loader open={isLoading} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="card shadow-sm">
        <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
          <h5 className="mb-0"><b>Directory of Internship Doing</b></h5>
          <div className="d-flex gap-2">
            <button className="btn btn-primary btn-sm" onClick={downloadExcel} disabled={isDownloading}>
              {isDownloading ? (
                <>
                  <svg className="me-2" style={{ width: "1.2rem", height: "1.2rem", animation: "spin 1s linear infinite" }} viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" strokeOpacity="0.25" />
                    <path d="M12 2C6.48 2 2 6.48 2 12" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
                  </svg>
                  Downloading...
                </>
              ) : (
                "Download Excel"
              )}
            </button>
            {/* <button
              className={`filter-icon-btn ${showFilters ? "active" : ""}`}
              onClick={() => setShowFilters(!showFilters)}
              title="Toggle Filters"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
              </svg>
            </button> */}
          </div>
        </div>

        <div className="card-body pt-0">
          <div className={`filter-container ${showFilters ? "show" : ""}`}>
            <div className="row align-items-end">
              <div className="col-md-3">
                <label className="form-label small">Status</label>
                <select
                  name="status"
                  className="form-control filter-select"
                  value={filters.status}
                  onChange={handleFilterChange}
                >
                  <option value="">All Statuses</option>
                  <option value="doing">Doing</option>
                  <option value="evaluation">Evaluation</option>
                  <option value="certified">Certified</option>
                </select>
              </div>
              <div className="col-md-2 d-flex gap-2">
                <button
                  className="filter-action-btn"
                  title="Reset Filters"
                  onClick={() => {
                    setFilters({
                      status: "",
                    });
                    setPage(1);
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                    <path d="M3 3v5h5"></path>
                  </svg>
                </button>
                <button
                  className="filter-action-btn close-btn"
                  title="Close Filters"
                  onClick={() => setShowFilters(false)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <CustomTable
            {...props}
            columns={[
              {
                title: "Intern Name",
                field: "internship",
                render: (row) => (
                  <div>
                    <div className="fw-bold">{row.internship?.full_name || "--"}</div>
                    <div className="x-small text-muted">{row.internship?.email}</div>
                  </div>
                ),
              },
              {
                title: "Company",
                field: "company",
                render: (row) => row.internship_request?.company?.company_name || "--",
              },
              {
                title: "Discipline",
                render: (row) => row.internship_request?.internship_discipline || "--"
              },
              // {
              //   title: "Timeline",
              //   render: (row) => (
              //     <div className="small">
              //       <div><b>S:</b> {row.start_date ? moment(row.start_date).format("DD-MMM-YYYY") : "--"}</div>
              //       <div><b>C:</b> {row.completion_date ? moment(row.completion_date).format("DD-MMM-YYYY") : "--"}</div>
              //     </div>
              //   ),
              // },
              // {
              //   title: "Status",
              //   field: "status",
              //   render: (row) => {
              //     const statusInfo = getStatusInfo(row.status);
              //     return (
              //       <span className={`status-badge ${statusInfo.class}`}>
              //         <span className="status-icon">{statusInfo.icon}</span>
              //         <span className="status-label">{statusInfo.label}</span>
              //       </span>
              //     );
              //   },
              // },
              {
                title: "Action",
                render: (row) => (
                  <div className="d-flex gap-1">
                    <button
                      className="btn btn-sm btn-outline-primary action-btn"
                      onClick={() => handleView(row)}
                      title="View Request"
                    >
                      <FiEye size={16} />
                    </button>
                  </div>
                ),
              },
            ]}
            data={data}
            paging={false}
            options={{
              search: true,
              selection: false,
              exportButton: false,
            }}
          />

          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="flex-grow-1"></div>
            <div className="btn-group">
              <button
                className="btn btn-sm btn-outline-primary"
                disabled={page === 1}
                onClick={() => setPage((p) => p - 1)}
              >
                Prev
              </button>
              {renderPagination()}
              <button
                className="btn btn-sm btn-outline-primary"
                disabled={page === totalPages}
                onClick={() => setPage((p) => p + 1)}
              >
                Next
              </button>
            </div>
            <div className="flex-grow-1 d-flex justify-content-end">
              <select
                className="form-control form-control-sm w-auto ml-2"
                value={perPage}
                onChange={handlePerPageChange}
                style={{ fontSize: "8px", height: "31px" }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="All">All</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
